import React, { Component } from 'react';
import { graphql } from 'gatsby';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import Blog from 'views/blog';
import Layout from 'components/layout';
import { NavBar, PopupRedirect } from 'components';
import { pages } from 'config/pages';
import config from '../../../meta/config';

export default class BlogPage extends Component {
  render() {
    const page = pages.blog;
    const { navColors } = page;
    const canonical = `${config.siteUrl}/blog/`;

    const { data } = this.props;

    const posts = data.posts.edges;
    const contributors = data.contributors.edges;

    const filters = data.filters.edges.map(item => ({
      name: item.node.frontmatter.title,
      order: item.node.frontmatter.order,
    }));

    return (
      <Layout {...{page, canonical}}>
        <Helmet title="Blog">
          <meta name={'description'} content={'Boldare magazine'} />
          <link rel="canonical" href={canonical} />
        </Helmet>
        <NavBar
          color={navColors}
          banner={{
            key: 'newsletter',
            newsletter: true,
          }}
        />
        <PopupRedirect message={'blog'} />
        <Blog posts={posts} contributors={contributors} filters={filters} />
      </Layout>
    );
  }
}

BlogPage.propTypes = {
  data: PropTypes.shape({
    posts: PropTypes.shape({ edges: PropTypes.array }),
    contributors: PropTypes.shape({ edges: PropTypes.array }),
    filters: PropTypes.shape({ edges: PropTypes.array }),
  }).isRequired,
};

export const pageQuery = graphql`
  query BlogPage {
    posts: allMarkdownRemark(
      sort: { order: DESC, fields: [frontmatter___settings___date] }
      filter: {
        frontmatter: {
          templateKey: { in: ["article-page", "case-study-page"] }
          settings: { category: { ne: "Case Study" } }
        }
      }
    ) {
      ...markdownFields
    }

    contributors: allMarkdownRemark(
      sort: { order: DESC, fields: [frontmatter___settings___date] }
      filter: {
        frontmatter: {
          templateKey: { eq: "contributor-page" }
          settings: { category: { ne: "Case Study" } }
        }
      }
    ) {
      ...markdownFields
    }

    filters: allMarkdownRemark(
      sort: { order: DESC, fields: [frontmatter___settings___date] }
      filter: {
        frontmatter: {
          templateKey: { eq: "category-page" }
          settings: { category: { ne: "Case Study" } }
        }
      }
    ) {
      edges {
        node {
          frontmatter {
            title
            order
          }
        }
      }
    }
  }
`;
